exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__product-card___SeyxO{display:flex;flex-flow:column;width:300px;height:450px;box-shadow:0 10px 30px rgba(44,62,80,.5)}", ""]);

// exports
exports.locals = {
	"product-card": "styles__product-card___SeyxO"
};